import { useAuth } from "./AuthContext";

export default function Dashboard() {
  const { user, loading, logout } = useAuth();

  if (loading) return <h3>Loading...</h3>;
  if (!user) return <h3>Loading...</h3>;

  return (
    <div className="page">
      <div className="card">
        <h1>Dashboard</h1>
        <p className="muted">Welcome to the dashboard</p>

        <div className="kv">
          <div className="kv-row">
            <div className="kv-label">User ID</div>
            <div className="kv-value">{user.userId}</div>
          </div>
          <div className="kv-row">
            <div className="kv-label">Email</div>
            <div className="kv-value">{user.email || "-"}</div>
          </div>
          <div className="kv-row">
            <div className="kv-label">Issued At</div>
            <div className="kv-value">{user.iatText}</div>
          </div>

          <div className="kv-row">
            <div className="kv-label">Expires At</div>
            <div className="kv-value">{user.expText}</div>
          </div>
        </div>


        <div style={{ marginTop: 20 }}>
          <button
            className="btn"
            onClick={() => {
              logout();
            }}
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}
